import { KEYS } from "./keys";
import { request } from "../axios";
import { encodeQueryData, handleApiError } from "../helper";
import {
  IOrderBookParams,
  IOrderBookResponse,
  IOrderBookSpreadsParams,
  IOrderBookSpreadsResponse,
  ITradesParams,
  ITradesResponse,
} from "./types";

export async function getTradesRequest(symbol: string, params: ITradesParams): Promise<ITradesResponse[]> {
  try {
    const filters = encodeQueryData(params);
    const { data } = await request.get(`${KEYS.TRADES(symbol)}?${filters}`);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getOrderBookRequest(symbol: string, params: IOrderBookParams): Promise<IOrderBookResponse> {
  try {
    const filters = encodeQueryData(params);
    const { data } = await request.get(`${KEYS.ORDER_BOOK(symbol)}?${filters}`);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getOrderBookSpreadsRequest(params: IOrderBookSpreadsParams): Promise<IOrderBookSpreadsResponse> {
  try {
    const filters = encodeQueryData(params);
    const query = filters ? `?${filters}` : "";
    const { data } = await request.get(`${KEYS.ORDER_BOOK_SPREADS()}${query}`);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}
